import DroppedPinIcon from "../components/DroppedPinIcon";
import FreeIcon from "../components/FreeIcon";
import Logo from "../components/Logo";
import ShieldElectricIcon from "../components/ShieldElectricIcon";
import Spec from "../components/Spec";
import EventCountdown from "../components/EventCountdown";
import EventDate from "../components/EventDate";
import Hero from "../components/Hero";
import Organizers from "../components/Organizers";
import ImageCarousel from "../components/ImageCarousel";
import VideoSection from "../sections/VideoSection";
import Sponsors from "../components/Sponsors";
import ButtonLink from "../components/ButtonLink";
import eventFormatPhoto from "../assets/spiderman.jpeg";
import post_logo from "../assets/spcs_logo.svg"
import video_image from "../assets/novotel_paradiso.jpg"
import harfanglab_logo from "../assets/sponsors/harfanglab.png"

import tenable_logo from "../assets/sponsors/tenable-logo.png";
import vectra_logo from "../assets/sponsors/vectra-logo.png";
import ywh_logo from "../assets/sponsors/YWH_logo.png"

//import airlock_logo from "../assets/sponsors/airlock-logo.png";
//import cribl_logo from "../assets/sponsors/cribl-logo.png";
//import karspersky_logo from "../assets/sponsors/karsperky-logo.png";
//import splunk_logo from "../assets/sponsors/splunk.png";
//import knowbe4_logo from "../assets/sponsors/knowbe4.png";
//import menlo_logo from "../assets/sponsors/menlo-security-logo.png";
//import one_identity_logo from "../assets/sponsors/one-identity.png";
//import c2sec_logo from "../assets/sponsors/c2sec-logo.png";
//import PlanningSection from "../sections/PlanningSection";
import Agenda from "../components/Agenda";
import ThankYouNote from "../components/ThankYouNote";

import speaker_sander_hofman from "../assets/speakers/Hofman_Sander.jpg";
import speaker_marcel_zumbuehl from "../assets/speakers/marcel-zumbuehl.png";
import speaker_thomas_cueni from "../assets/speakers/thomas-cueni.jpg";
import speaker_ralph_el_khoury from "../assets/speakers/El-Khoury_Ralph.jpg";
import speaker_chris_fichera from "../assets/speakers/Fichera_Christian_small.jpg";


import SpeakerSection from "../sections/SpeakerSection";
import elastic_logo from "../assets/sponsors/elastic-logo-reverse.svg";
/*
import infomaniak from "../assets/infomaniak.png";
import pwc_outlined_logo from "../assets/pwc_outlined_logo.png";
import hkta_logo from "../assets/hkta_logo.png";

import sentinel_one from "../assets/sponsors/SentinelOne_Logo_white-purple.png";
import fortinet_logo from "../assets/sponsors/fortinet-logo.png";
import cyberreason from "../assets/sponsors/cyberreason-logo.png";
import threatray from "../assets/sponsors/threatray-logo.png";
import speaker_daniel_kuenzli from "../assets/speakers/daniel-kuenzli.png";
import speaker_rene_bodmer from "../assets/speakers/rene-bodmer.png";
import speaker_luca_bertolotto_cipriani from "../assets/speakers/luca-bertolotto.png";
import speaker_fabian_gentinetta from "../assets/speakers/fabian_gentinetta.jpeg";
import speaker_martin_de_jongh from "../assets/speakers/MartinDJ_SentinelOne.png";
import speaker_eric_de_bressing from "../assets/speakers/eric-de-bressing.jpeg";
import speaker_patrick_buchholz from "../assets/speakers/patrick-buchholz.jpg";
import speaker_detlev_narr from "../assets/speakers/detlev-narr.png";
*/
import speaker_unknown from "../assets/speakers/unknown_person.jpg";



const eventDate: Date = new Date(2026, 5, 16, 12, 45); // 16 june 2026

export default function LuganoEventTab() {
  return (
    <div className="container">
      <ThankYouNote />
      <section>
        <div style={styles.logoContainer}>
          <Logo width="auto" height="102px" />
        </div>
        <EventDate date={eventDate} />
        <Hero
          title="Lugano’Hack"
          subtitle="Taking cybersecurity seriously, but not ourselves<br><br>A keynote presentation with inspiring insights from the perspective of a well-known CISO, exciting input presentations, and good networking opportunities await you. Aimed at Cybersecurity Experts, IT enthusiasts and Students with a Networking Apero in the evening"
          titleStyle={styles.title}
          subtitleStyle={styles.subtitle}
        />
        <div className="specs-container">
          <Spec icon={<DroppedPinIcon />} title="Novotel Paradiso" url="https://maps.app.goo.gl/f3pcpStw7QoPY13Z9" />
          <Spec icon={<FreeIcon />} title="100% Free" />
          <Spec icon={<ShieldElectricIcon />} title="100% cybersecurity" />
        </div>
        <EventCountdown date={eventDate} />
      </section>
      <section>
        <ButtonLink
          href="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594595/"
          newTab={false}
          style={{ maxWidth: "161px" }}
        >
          Register
        </ButtonLink>
      </section>
      {/*
      <section>
        <AboutTheEvent mapUrl="./palexpo-plan.pdf"/>
      </section>
      */}
      {/*
      <section>
        <EventFormat imageSrc={eventFormatPhoto}/>
      </section>
      */}
      {
      <section>
        <Agenda
          headers={['', '']}
          agenda={[
            { time: "11:30 - 13:00", description1: "Registration and Lunch" },
            { time: "13:00 - 13:30", description1: "Opening Ceremony" },
            { time: "13:30 - 14:00", description1: "Keynote Speech,  Beyond Cybersecurity [Marcel Zumbühl, CISO of Swiss Post]" },
            { time: "14:00 - 14:30", description1: "Threat Landscape Report by Swiss Post Cybersecurity" },
            { time: "14:30 - 15:00", description1: "Defending against legitimate tools. How to protect yourself when attackers reuse your own tools? [HarfangLab]" },
            { time: "15:00 - 15:25", description1: "Networking Break" },
            { time: "15:25 - 17:15", description1: "<b>Technical Presentations</b><ul><li>Supply Chain in a ZIP: The Forgotten File That Compromised Everyone<br>[Ralph El Khoury, Senior Offensive Security Engineer, Swiss Post Cybersecurity]</li><li>CISO/vCISO as a Service: the Game-Changing Real-World Experience!<br>[Chris Fichera, Director Consulting & Integration, Swiss Post Cybersecurity]</li><li>What Happens When the Attacker's AI Works Harder Than Your Entire SOC?<br>[Sven Kirchmayer, Senior Solution Architect, Elastic]</li><li>Surviving the Vulnami [Thomas Cueni, Tenable]</li>" },
            { time: "17:15", description1: "Apero and Networking" }
          ]
          }
        ></Agenda>
      </section>
      }
      {/*
      <section>
        {
        <PlanningSection
        title="Details"
        subtitle=""
        displayGrid="grid"
        planning={[
          {
            time: "12:00",
            title: "",
            description: "<h1>Lunch</h1>",
            index: 0,
          },
          {
            time: "",
            title: "Network meets Identity: Modern detection and response for the hybrid world<br><small>Vectra - Fabian Gentinetta / Christian Borst</small>",
            description: "The modern network has changed. We went remote, and into the cloud. The cloud grew, and became more complex. Today, Active Directory and Entra ID stand at the core of most networks. IT and OT are converging, into one giant attack surface. In this talk, we offer strategic perspectives on how to navigate and secure this new reality.",
            index: 1,
          },
          {
            time: "",
            title: "Post Login: Stopping Lateral Movement with Privileged Access Analytics<br><small>Vectra - Aurélien Hess / Christoph Riese / Fabian Gentinetta</small>",
            description: "Attackers know the complexities of managing account permissions across network, cloud and SaaS apps leave gaps for them to abuse. Privileged accounts are routinely used to steal sensitive information and disrupt operations, without ever needing to run an exploit. Some SOC teams focus on monitoring failed login attempts and unusual user behavior, and lean on multi-factor authentication (MFA) to reduce risk. The truth is, those security measures are just one part of the ATO protection equation. You need a proven way to see and stop account takeover attacks in real time.",
            index: 2,
          },
          {
            time: "",
            title: "Searching or finding? In front of or behind your line(s) of defense?<br><small>Kaspersky - Detlev Narr</small>",
            description: "You probably already have the tools! What rules to write? What data to correlate? How to stay up to date? The presentor answers these questions and more, and showcases how you can use Threat Intelligence to improve your organization's security.",
            index: 3,
          },
          {
            time: "",
            title: "Human Risk Management based on AI<br><small>KnowBe4 - Paul Nkengue </small>",
            description: "This presentation focuses on what is probably the most unpredictable part of the IT security equation: people. From phishing attacks and poor password practices to careless handling of sensitive data, learn how to tackle these issues efficiently and effectively.",
            index: 4,
          },
          {
            time: "",
            title: "Goodbye Purple Team, Hello Purple Bots<br><small>Swiss Post Cybersecurity - Patrick Mkhael & Ralph El-Khoury</small>",
            description: "This talk unveils a fully automated, AI-driven purple teaming framework that simulates real-world APT attacks, evaluates detection capabilities, and enhances security defense, all in real-time.",
            index: 5,
          },
          {
            time: "",
            title: "Tenable One: Holistic Exposure Management<br><small>Tenable - Thomas Cueni</small>",
            description: "Threat actors do not adhere to silos in the security field. They look for vulnerabilities of all kinds to exploit and move laterally through the environment. But the tools organizations rely on to secure their attack surface often focus only on individual technologies - cloud, identities, IT, OT, IoT, applications - and generate an enormous amount of unnecessary data. What's missing is a cross-functional view of the relationships between assets, identities and risks that enable attacks, and more importantly, the impact on the organization, whether in terms of revenue, data sovereignty, compliance or other critical metrics.<br>The Tenable One exposure management platform unifies visibility, insights and actions across the entire attack surface. ",
            index: 6,
          },
          {
            time: "",
            title: "Capabilities of Modern Security Platforms<br><small>Splunk - Jürg Fischer / Eric De Bressing</small>",
            description: "The right tool for the right job: old and new critical capabilities for SecOps & Enterprise Resilience",
            index: 7,
          },
          {
            time: "",
            title: "Beyond Compliance: Building Resilient & Secure Third-Party Ecosystems<br><small>C2SEC - Renato Martignoni</small>",
            description: "Increasing third-party cyberattacks highlight why vendor risk must go beyond compliance and become part of everyday security operations. This session explores how organizations can leverage evolving regulations like DORA to move beyond one-time compliance toward building continuously secure third-party ecosystems.",
            index: 8,
          },
          {
            time: "",
            title: "A Modern Approach to Telemetry Data Management<br><small>Cribl - Sven Eichfuss / Christoph Dittmann</small>",
            description: "The tidal wave of data is rising, asking for a modern approach to managing and utilizing telemetry data. Cribl will highlight the value of providing teams with ownership over their data while ensuring overall governance and security.",
            index: 9,
          },
          {
            time: "",
            title: "Shadows in the Cloud: Unmasking Advanced Evasion Techniques <br><small>Menlo - Tom McVey / Brett Raybould</small>",
            description: "This session exposes the mechanics behind today's most sophisticated cloud-based attacks. Through live demonstrations of credential phishing and HTML smuggling techniques, Menlo Security's experts will dissect how threat actors bypass traditional security controls. Participants will witness firsthand how these attacks unfold and learn the architectural approaches needed to defend against browser based threats",
            index: 10,
          },
          {
            time: "",
            title: "Threat modeling and it's importance<br><small>Post  - Heinz Wittig </small>",
            description: "In the past two years, the Swiss Post team has embarked on the complex journey of implementing Threat Modeling, akin to the journeys of the companions through Middle-earth. Along the way, they faced challenges reminiscent of the trials of Moria and the watchful eye of Sauron, as well as threats and resistance. Through perseverance and collaboration, they overcame these obstacles and learned more about potential security risks and their early identification. Join them on their adventure and discover the key lessons and strategies that have led them to success in the ever-evolving world of cybersecurity",
            index: 11,
          },
          {
            time: "",
            title: "One Identity Fabric - foundation for modern identity management<br><small>OneIdentity - Reto Bachman / Eric Parietti</small>",
            description: "Presentation of an ecosystem that enables organizations to implement authentication and authorization for all identities (including general users, privileged accounts and third parties) across the entire infrastructure.",
            index: 12,
          },
          {
            time: "",
            title: "Tabletop Exercises: Because real Chaos has no pause button<br><small>Swiss Post Cybersecurity - Greg Divorne </small>",
            description: "We’ll break down the real value of cybersecurity table-tops — no simulations, just sharp insights, common pitfalls, and how to make chaos a little more manageable.",
            index: 13,
          },
          {
            time: "",
            title: "OT Security: Tips & Tricks<br><small>Swiss Post Cybersecurity - Christian Fichera & Ryan Steiger</small>",
            description: "OT and IT are different in many ways, and cybersecurity is certainly one of them. Priorities, vulnerabilities and how to remediate them are all key differences between these two worlds.<br>As a pentester, the way you approach assessing IT and OT environments needs to be different too, and the specific knowledge a tester has in the OT world can make the difference between a successful test and a broken OT device.<br>A demo taken from real life pentesting experience will also show how easy it can be to compromise OT environments.",
            index: 14,
          },
          {
            time: "",
            title: "Threat Hunting Basics<br><small>Swiss Post Cybersecurity - Antony Ancelin</small>",
            description: "From Intel to Hunts. Threat hunting isn’t new but this session is a practical reminder of the basics. Learn how to use threat intelligence to build hunting hypotheses, assess visibility gaps, and take action when signs of compromise are foundWe will also discuss common challenges MSSPs face when handling CTI and provide a practical example of using CTI use case.",
            index: 15,
          },
          {
            time: "17:00",
            title: "",
            description: "<h1>Apero and Networking</h1>",
            index: 16,
          }
        ]}
        />
        }
      </section>
      */}
      {<section>
        {
        <SpeakerSection
          title=""
          subtitle="Attendees will leave feeling more connected to a community of builders and to the future of the evolving world of cybersecurity"
          speakers={[
            {
              firstName: "Marcel",
              lastName: "Zumbühl",
              role: "CISO of Swiss Post",
              title: "Beyond Cybersecurity",
              description:
                "Cybersecurity today is shaped by speed, digital trust and human behavior rather than by technology alone. This talk explores how resilience, participation and culture turn people into the strongest link in an ever‑changing story centered around customers.",
              image:
                speaker_marcel_zumbuehl,
            },
            {
              firstName: "Sander",
              lastName: "Hofman",
              role: "Solution Engineer, HarfangLab",
              title: "Defending against legitimate tools. How to protect yourself when attackers reuse your own tools?",
              description:
                "8 out of 10 attacks no longer use malware. Attackers, whether ransomware operators or state-sponsored groups, now leverage your own administration tools to conduct their operations. PowerShell to execute code in memory, PsExec to deploy ransomware across an entire fleet... No malicious file, no signature to detect: this is the principle of Living-off-the-Land. It was recently discovered that the Chinese group Volt Typhoon had maintained stealthy access for several years within American critical infrastructure, using nothing but native system tools. On the ransomware side, groups like BlackCat or Black Basta systematically rely on these same techniques to bypass existing security solutions. How do you detect what appears legitimate but is actually malicious? Which signals should you prioritize monitoring?  This presentation aims to shed light on the mechanisms behind Living-off-the-Land and fileless attacks through concrete cases, and to propose best practices to regain the upper hand.",
              image:
                speaker_sander_hofman,
            },
            {
              firstName: "Thomas",
              lastName: "Cueni",
              role: "Tenable",
              title: 
                "Surviving the Vulnami",
              description:
                "How to prepare for the flood of new vulnerabilities found by AI by automatically finding, prioritizing, and fixing the ones that really matter.<br><br>With frontier AI models like Claude Mythos, the number of new vulnerabilities will increase faster than human teams can react. When attacks happen at machine speed, traditional security just isn't enough. In this talk, we’ll explore how to fight back using the Tenable One platform.<br><br>The session will focus on:<br><ul><li> Prioritization: How to cut through the noise and focus on the 1% of vulnerabilities that truly matter.</li><li> Toxic Combinations & Attack Paths: How to focus on actual exposures that attackers leverage rather than theoretical vulnerabilities.</li><li> Mobilization & Agentic Remediation: How to use agentic AI as your automated defense partner, closing the gap between finding a problem and fixing it so you can finally remediate at machine speed.</li></ul>",
              image:
              speaker_thomas_cueni,
            },
            {
              firstName: "Ralph",
              lastName: "El Khoury",
              role: "Senior Offensive Security Engineer, Swiss Post Cybersecurity",
              title: 
                "Supply Chain in a ZIP: The Forgotten File That Compromised Everyone",
              description:
                "One file. One vulnerability. Hundreds of organizations compromised. This talk presents a real-world supply chain attack that began with a single discovery: an unauthenticated ZIP file (DELETE_ME.zip) exposed in the directory of an ERP web application. Inside: the application's complete source code. Our analysis uncovered a critical unauthenticated RCE zero-day, plus JAR files containing hardcoded credentials for Azure Blob Storage, AWS, and Power BI. We'll walk through the full kill chain: exploiting the zero-day RCE to compromise the initial client, then realizing the same vulnerability existed in every deployed instance, meaning every organization running this ERP software was equally exploitable. But it didn't stop there. The hardcoded cloud credentials extracted from the JAR files gave us direct access to the ERP provider's cloud infrastructure: customer data backups, business intelligence dashboards, and production environments across Azure and AWS. A forgotten ZIP file turned a single client engagement into a supply chain catastrophe, one vulnerability to rule them all. Attendees will learn how small oversights cascade into massive breaches, how to identify hardcoded secrets in compiled artifacts, and what defensive measures could have stopped this attack at every stage.",
              image:
              speaker_ralph_el_khoury,
            },
            {
              firstName: "Chris",
              lastName: "Fichera",
              role: "Director Consulting & Integration, Swiss Post Cybersecurity",
              title: 
                "CISO/vCISO as a Service: the Game-Changing Real-World Experience!",
              description:
                "In an increasingly complex cybersecurity landscape, many organizations struggle to recruit or retain a qualified CISO. The CISO/ vCISO (Virtual CISO) models, delivered as part of our managed GRC offering, provide concrete and proven answers. Through this real-world RetEx, we share key lessons learned from our CISO/vCISO engagements: security maturity gains, governance structuring, risk management, and regulatory compliance (e.g. DORA, ICT Minimum Standard, ISO 27001, NIS2 enforced by usage of GRC dedicated Tools AI embedded). We demonstrate how this service enables our clients — mid-sized enterprises, public sector organizations, and regulated industries — to benefit from strategic CISO expertise on a shared-time basis, combining the agility of an MSSP partner with the depth of a dedicated expert.",
              image:
              speaker_chris_fichera,
            },
            {
              firstName: "Sven",
              lastName: "Kirchmayer",
              role: "Senior Solution Architect, Elastic",
              title: 
                "What Happens When the Attacker's AI Works Harder Than Your Entire SOC?",
              description:
                "In late 2025, Anthropic reported what it described as the first publicly documented AI-orchestrated cyber espionage campaign — a signal that offensive AI is moving from experimentation to operational scale. At the same time, most security teams remain understaffed, overloaded with alerts, and constrained by fragmented tooling built for human-speed response. This session examines what changes when attackers can use AI to accelerate reconnaissance, decision-making, and execution faster than defenders can hire or manually investigate. We’ll look at emerging attack patterns, why platform consolidation matters more than ever, and how security teams can use AI to improve detection, investigation, and response. We’ll also discuss how Elastic helps defenders unify telemetry, reduce tool sprawl, and apply AI in ways that make SOC teams faster, more consistent, and more resilient.",
              image:
              speaker_unknown,
            }
          ]}
        />
        }
      </section>}
      {
      <Sponsors
        style={{ marginTop: "120px" }}
        logos={[
          [harfanglab_logo],
          [elastic_logo, tenable_logo, vectra_logo],
          [ywh_logo]
        ]}
      />
      }
      <section>
        <Organizers
          organizers={[
            { src: post_logo, name: "Swiss Post Cybersecurity" }
          ]}
        />
      </section>
{       <ImageCarousel
        images={[
          eventFormatPhoto,
          "/img/21efdf712cf79fbd148856011f58bc6e.jpeg",
          "/img/2205cda10dfebc8d1ca3a5bbf2f8515e.jpeg",
          "/img/a7dc9838a6d79336be95edcbb10943c9.jpeg",
          "/img/c67f653b353385bcc7e424359aa6b3e8.jpeg",
          "/img/d6b45f79c4a62172598e9531d0587924.jpeg"
        ]}
        borderRadius="20px"
        height="284px"
        width="90%"
      /> }
      <section>
        <VideoSection
          video="https://maps.app.goo.gl/f3pcpStw7QoPY13Z9"
          title="Lugano'Hack"
          registerUrl="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594595"
          image={video_image}
        />
      </section>
    </div>
  );
}

const styles = {
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    background: "linear-gradient(90deg, #FFF 27.78%, #E1E1E1 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontFamily: "Poppins",
    fontSize: `${window.outerWidth < 768 ? "12vw" : "5vw"}`,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    margin: 0,
  },
  subtitle: {
    fontFamily: "Arvo",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "-18px",
    textAlign: "center" as "center",
  },
};
